import { useState, useEffect } from "react";
import axios from "axios";
import baseurl from "../../../CrudOperations/customURl";
import { ReserveAutoAllotementOperation } from "../../../CrudOperations/PostOperation";
import { toast } from "react-toastify";

const apiBase = baseurl;

const useFull_ReserveDutyAllotemetn_Hook = () => {
    const [department, setDepartmentData] = useState("");
  const [checkpoints, setCheckpoints] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);

  const [formData, setFormData] = useState({
    DeputyCheckpointName: "",
    DistrictId: "",
    StateId: "",
    Pincode: "",
    CommunityId: "",
    Gender: "Male",
    LandMark: "",
    StartDate: "",
    EndDate: "",
    StartTime: "",
    EndTime: "",
    CheckpointSkills: [],
  });
  const [numberOfDeputation, setNumberOfDeputation] = useState(0);
  const [staffIds, setstaffIds] = useState([]);

  const [editCheckpoint, setEditCheckpoint] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchCheckpoints = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${apiBase}/DeputyCheckpoint/GetDeputyCheckpoint`);
      setCheckpoints(res?.data?.Data || []);



        const resGetDepartmentList = await axios.get(`${apiBase}/staff/GetDepartmentList`);
        console.log(resGetDepartmentList);
        
      setDepartmentList(resGetDepartmentList?.data?.Data || []);




    } catch (err) {
      console.error("Fetch Checkpoints Error:", err);
    } finally {
      setLoading(false);
    }
  };


    const handleSelectDepartMent = async (e) => {
      const value = e.target.value || null;
      setDepartmentData(value);

      console.log(value);
      
  
      try {
      const res = await axios.get(`${apiBase}/staffSkills/GetStaffByDepartment/${value}`);
      console.log(res);


      if(res?.data?.length > 0){


                      setstaffIds(res?.data)
          setNumberOfDeputation(res?.data?.length)


      }



      
  
       
  
        // let staffs = response?.data?.Staff;
        // const TotalNeeded = response?.data?.TotalNeeded;
  
        // console.log(TotalNeeded);
  
        // const updatedStaffIds = staffs?.map((element) => element.StaffId) || [];
        // console.log(staffs);
        // if (staffs.length <= 0) {
        //   console.log(staffs);
  
        //   const array = [];
  
        //   while (array.length < TotalNeeded) {
        //     array.push("");
        //   }
  
        //   console.log(array);
  
        //   setstaffIds(array);
        //   setNumberOfDeputation(TotalNeeded);
        // } else {
        //   setReplaceMentEnabled(true);
  
        //   console.log(staffs);
  
        //   const data = staffs.map((ele) => ele.StaffId);
        //   console.log(data);
  
        //   setstaffIds(data);
  
        //   setNumberOfDeputation(TotalNeeded);
        // }



      } catch (error) {
        toast.error(
          error?.response?.data?.message || error?.response?.data?.ServerMessage
        );
      }
    };
  



  useEffect(() => {
    fetchCheckpoints();
  }, []);

 const submitForm = async (AllotementType, selectedDeputyCheckpointId) => {
    if (AllotementType === "Auto") {
      try {
        const response = await ReserveAutoAllotementOperation(
          selectedDeputyCheckpointId
        );
        console.log(response);

        if (response?.data?.Message === "Success") {
          fetchCheckpoints();

          toast.success(response?.data?.Message);
        } else {
          toast.error(
            response?.data?.error ||
              response?.data?.Message ||
              response?.data?.message ||
              response?.data?.serverMessage
          );
        }
      } catch (err) {
        toast.error(
          err?.response?.data?.error ||
            err?.response?.data?.Message ||
            err?.response?.data?.message
        );
      }
    }
  };


 const handleEdit = (checkpoint) => {
  setFormData({
    DeputyCheckpointName: checkpoint.DeputyCheckpointName || "",
    DistrictId: String(checkpoint.DistrictId || ""),
    StateId: String(checkpoint.StateId || ""),
    Pincode: String(checkpoint.Pincode || ""),
    CommunityId: String(checkpoint.CommunityId || ""),
    Gender: checkpoint.Gender || "Male",
    LandMark: checkpoint.LandMark || "",
    StartDate: checkpoint.StartDate ? checkpoint.StartDate.split("T")[0] : "", // assuming ISO format
    EndDate: checkpoint.EndDate ? checkpoint.EndDate.split("T")[0] : "",
    StartTime: checkpoint.StartTime || "",
    EndTime: checkpoint.EndTime || "",
    CheckpointSkills: checkpoint.CheckpointSkills?.map(s => ({
      SkillId: s.SkillId?.toString() || ""
    })) || [],
  });

  setEditCheckpoint(checkpoint);
};


  const resetForm = () => {
    setFormData({
      DeputyCheckpointName: "",
      DistrictId: "",
      StateId: "",
      Pincode: "",
      CommunityId: "",
      Gender: "Male",
      LandMark: "",
      StartDate: "",
      EndDate: "",
      StartTime: "",
      EndTime: "",
      CheckpointSkills: [],
    });
    setEditCheckpoint(null);
  };

  return {
    staffIds,
numberOfDeputation,
    department,
    handleSelectDepartMent,
    departmentList,
    checkpoints,
    formData,
    setFormData,
    submitForm,
    fetchCheckpoints,
    editCheckpoint,
    setEditCheckpoint,
    handleEdit,
    resetForm,
    loading,
  };
};

export default useFull_ReserveDutyAllotemetn_Hook;

